import { CaseStatusTypes } from "interfaces/case-status-type";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: CaseStatusTypes[];
}

interface LazyFetchPriority {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetCaseStatusTypes = (): {
  loading: boolean;
  error: boolean;
  fetchCaseStatusTypes: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const { loading, error, fetchCallback }: LazyFetchPriority = useLazyFetchV2(
    "GET"
  );

  return {
    loading,
    error,
    fetchCaseStatusTypes: (queryString?: string) =>
      fetchCallback(`case_status_types?${queryString ?? ""}`)
  };
};
